import React from 'react';
import Button from "../base/Button"
import deleteRequest from "./feedDeleteButtonRequest"

class FeedDeleteButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = { loading: false, status: false, isToggleOn: true, errorResponse: false };

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState(state => ({ loading: true, errorResponse: false }))

        deleteRequest(this.props.id) 
            .then((conf) =>  {
                this.setState(state => ({ loading: false }));
                
                if (conf.error) { 
                    console.warn("deleteRequest error", conf)
                    this.setState({ errorResponse: conf.error.toString()})                    

                    if (conf.error.response && conf.error.response.status) {
                        this.props.deleteErrorCb({ status: conf.error.response.status, errorResponse: conf.error.response.status })
                    return null;  
                    } 
                }
                 
                if (conf && conf.status) {
                    this.setState({status:conf.status})
                }

                if (conf && conf.status && conf.status === 200) {
                    this.setState(state => ({ isToggleOn: !state.isToggleOn }));
                    this.props.deleteSuccessCb()
                }                
            })            
            .catch((conf) =>  {
                console.warn("FeedDeleteButton catch conf", conf)
            })
    }

    render () {   
        let deleteText = "löschen" 
        if (this.state.loading) {
            deleteText = "spinner"
        }

        return <Button type="button" layout="delete" action={this.handleClick}>{deleteText}</Button>  
    }
}

export default FeedDeleteButton